import React from "react";
import { Field, ErrorMessage } from "formik";
import {
  FormControl,
  FormControlLabel,
  Box,
  InputLabel,
  OutlinedInput,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
const TextArea = (props) => {
  const { name, label, type, view, rows, ...rest } = props;

  const sxStyle = {
    color: "#fff",
    borderRadius: "4px",
    padding: "8px",
    textAlign: "center",
    width: "100%",

    "& .muirtl-aqwd4r-MuiFormLabel-root-MuiInputLabel-root": {
      color: "yellow",
    },
  };

  return (
    <Field>
      {({ field, form }) => {
        return (
          <FormControl sx={sxStyle}>
            <Field
              error={form.errors[name] && form.touched[name]}
              as={TextField}
              label={label}
              variant="outlined"
              name={name}
              id={name}
              {...rest}
              type={'textArea'}
              size={`${view === 2 ? "large" : "small"}`}
              multiline
              rows={rows ? rows : 3}
            ></Field>
          </FormControl>
        );
      }}
    </Field>
  );
};

export default TextArea;

/**========================================================================
 *              1402/10/22      user:javadBoroji
 *             TODO: add Props Rows
 *
 *      Description: برای کنترل کردن ارتفاع فیلد
 *
 *
 *
 *========================================================================**/
